// Import Firebase modules (for Firebase v9+)
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyA46Wd41JcgEoyovWXHlBd4AZGWwIqBsjc",
    authDomain: "netflix-clone-9038b.firebaseapp.com",
    projectId: "netflix-clone-9038b",
    storageBucket: "netflix-clone-9038b.firebasestorage.app",
    messagingSenderId: "856060473548",
    appId: "1:856060473548:web:1d46fd7a4b84f5d4a79269"
  };
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app); // Firestore database
const auth = getAuth(app); // Authentication

export { db, auth };
